import { IntegrityMonitorRealTimePanelBaseDataProvider } from './IntegrityMonitorRealTimePanelBaseDataProvider';
import { IntegrityMonitorRealTimePanelWebComponentSchema } from '../types';

export class IntegrityMonitorRealTimePanelGzDataProvider extends IntegrityMonitorRealTimePanelBaseDataProvider {
  async getDataForView(): Promise<IntegrityMonitorRealTimePanelWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
